/* eslint-disable react-hooks/exhaustive-deps */
import { FC, useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import SubmitButton from 'components/atoms/buttons/SubmitButton'
import InputField from 'components/atoms/fields/InputField'

import useCrudData from "utils/customHooks/useCrudData"
import { crudColorMap, crudIconMap } from 'utils/helpers'

import {
    useDELETE_rtiRiskCriteriaThreeMutation,
    useGET_rtiRiskCriteriaThreeByIdQuery,
    usePOST_rtiRiskCriteriaThreeMutation,
    usePUT_rtiRiskCriteriaThreeMutation,
} from 'redux/api/rtiApi'
import { useGET_schoolSetupConcernReasonsSelectQuery } from 'redux/api/setupApi'
import { useGET_learningStyleQuestionsQuery, useGET_studentByProfileIdQuery, useGET_studentsProfileSelectQuery } from 'redux/api/studentsApi'

import formModel, { initialValues } from 'utils/formModels/rtiRiskCriteriaThreeModel'

import { Form, Formik } from 'formik'
import { Box, Button, Grid } from '@mui/material'
import { ActionType, IStudent } from 'types'
import SelectField from 'components/atoms/fields/SelectField'
import { FaChevronLeft } from 'react-icons/fa'
import _ from 'lodash'
import React from 'react'
import StudentCard from 'components/utilized/students/studentCard'
import KpiPerformanceChart from 'components/utilized/kpi/KpiPerformanceChart'


interface IProps {
  action: ActionType
  id: string
  currentStudent?: any
  viewOnly: boolean
}

const RiskCriteriaThreeForm: FC<IProps> = ({  action, id, currentStudent = null, viewOnly }) => {
 
  const { t } = useTranslation()
  const navigate = useNavigate()
  
  const backToSlug =  currentStudent ? `/rti-students/${currentStudent.id}#reasons ` : `/rti-concerns`

  const { isLoading, entity, handleSubmit } = useCrudData({
    backToSlug,
    entityName: `${t('common.concern-reasons')}`,
    entityId: id,
    getEntityQuery: useGET_rtiRiskCriteriaThreeByIdQuery,
    createEntityMutation: usePOST_rtiRiskCriteriaThreeMutation,
    editEntityMutation: usePUT_rtiRiskCriteriaThreeMutation,
    deleteEntityMutation: useDELETE_rtiRiskCriteriaThreeMutation,
  })

  const {
      student,
      concern_reasons,
      task_demands,
      problem_description,
      expected_performance,
  } = formModel()


  const serverValues = entity?.id ? entity : {}

  const selectedStudent = entity?.id 
    ? serverValues.student.title 
    : currentStudent 
      ? currentStudent.first_name+' '+currentStudent.last_name+' ['+currentStudent.academic_id+']'
      : null

  const formValues = {
    ...initialValues,
    ...serverValues
  } 



   const [optionStudent, setOptionStudent] = useState(null)
  
  const {data: studentData} = useGET_studentByProfileIdQuery(optionStudent ? optionStudent.id : null,{skip: !optionStudent})
  
  const {
    data: learningStyle,
  } = useGET_learningStyleQuestionsQuery(optionStudent ? optionStudent.id : null, {skip: !optionStudent})

  useEffect(() => {
     if (serverValues?.student && !optionStudent) {
      setOptionStudent(serverValues.student)
     }
   }, [serverValues?.student])
    

  return (
    <Formik
      enableReinitialize
      initialValues={formValues}
      onSubmit={(values: any) => {
        const data = {
          ...values,
          student_id: currentStudent ? currentStudent.student_profile_id : (values?.student?.id ?? ''),
          concern_reasons_ids: values.concern_reasons.map((a) => a.id),
        }

        handleSubmit(action, entity?.id, data)
      }}
    >
      {({ values, setFieldValue, errors }) => {
        return (
          <Form>

            {values.student && studentData && <Box mt={1} mb={3}>
               <Grid container spacing={4}>
                   <Grid item xs={12} md={4}><StudentCard student={studentData} learningStyle={learningStyle} step={1}/></Grid>
                   <Grid item xs={12} md={8}>
                       <KpiPerformanceChart filters={{ student: values.student.id }}/>
                  </Grid>
                 </Grid>
           </Box>}



            <Grid container spacing={2} sx={{ marginTop: '-1rem' }}>
              <Grid item xs={12} md={4} sx={{ paddingTop: '20px !important', paddingBottom: '20px !important;' }}>
                {
                  selectedStudent && <b>{selectedStudent}</b>
                }   
                {
                  !selectedStudent && <SelectField
                    fieldProps={{
                      ...student,
                    }}
                    apiCall={useGET_studentsProfileSelectQuery}
                    disabled={viewOnly}
                    onChange={(value) => {
                        setOptionStudent(value)
                    }}
                  />
                }
              </Grid>
            </Grid>

            <Grid container spacing={2}>          
              <Grid item xs={12} md={4}>
                <InputField multiline={true} fieldProps={{ ...task_demands }} />
              </Grid>
              <Grid item xs={12} md={4}>
                <InputField multiline={true} fieldProps={{ ...problem_description }} />
              </Grid>        
              <Grid item xs={12} md={4}>
                <InputField multiline={true} fieldProps={{ ...expected_performance }} />
              </Grid>

              <Grid item xs={12}>
                <div><b>{t('rti.sample-definitions')}</b></div>
              </Grid>

              {
                _.range(1,6).map(i => <React.Fragment key={`row-${i}`}>
                  <Grid item xs={12}>
                    <div style={{ borderBottom: '1px dashed rgba(0,0,0,0.6)' }}></div>
                  </Grid>
                  {
                    _.range(1,4).map(j => <Grid item xs={12} md={4} key={`col-${i}-${j}`}>{t(`rti-risk-criteria.question-${i}-${j}`)}</Grid>)
                  }
                </React.Fragment>)
              }

              <Grid item xs={12}>
                <div style={{ borderBottom: '1px dashed rgba(0,0,0,0.6)' }}></div>
              </Grid>
              
              <Grid item xs={12} sx={{ marginTop: '20px' }}>
                <SelectField
                  fieldProps={{ ...concern_reasons }}
                  apiCall={useGET_schoolSetupConcernReasonsSelectQuery}
                  multiple={true}
                />
              </Grid>

            </Grid>

            <Grid container spacing={4} sx={{ marginTop: '1rem' }}>
              <Grid item xs={12}>
                {/* ACTIONS */}
                <Box sx={{ marginTop: '20px' }} className="transparent-background">
                  <Box sx={{ display: 'inline-block' }}>   
                    <Button
                      variant='outlined'
                      color='black'
                      onClick={() => navigate(backToSlug)}
                      sx={{ minHeight: '2.5rem', width: '10rem' }}
                    >
                      <FaChevronLeft style={{ fontSize: '1.1rem', margin: '-3px 0.5rem 0 -0.5rem' }} />
                      {`${t('common.back')}`}
                    </Button>
                  </Box> 
                  <Box sx={{ display: 'inline-block', marginLeft: '10px' }}>   
                    <SubmitButton
                              color={crudColorMap[action]}
                              text={`${t('form-actions.' + action)}`}
                              icon={crudIconMap[action]}
                              sx={{ minHeight: '2.5rem', width: '10rem' }}
                              isLoading={isLoading}
                          />
                  </Box>   
                </Box>   
              </Grid>
            </Grid>
          </Form>
        )
      }}
    </Formik>
  )
}
export default RiskCriteriaThreeForm
